const Loading = () => <div className="page-loading"></div>

export default Loading
